// Adapted from transitions-pro/spinner-check-morph/react.md.
// Dalia's motion rules replace the rotating arc with an opacity pulse and
// remove the hop, pop, cross-blur and stroke animation.
export function StatusMark({ state }: { state: "loading" | "done" }) {
  return (
    <span className="status-mark" data-state={state} aria-hidden="true">
      <span className="status-ring" />
      <span className="status-disc">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M8 12.5L10.8 15.5L16.4 9.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
    </span>
  );
}
